import React, { useEffect, useState, useRef } from "react";
import NoAIOutput from "../../components/SVGComponents/NoAIOutput";
import NonFrontal from "../../components/SVGComponents/NonFrontal";
import Low from "../../components/SVGComponents/Low";
import Medium from "../../components/SVGComponents/Medium";
import High from "../../components/SVGComponents/High";
import Critical from "../../components/SVGComponents/Critical";
import Suspect from "../../components/SVGComponents/Suspect";
import ForeignBody from "../../components/SVGComponents/ForeignBody";
import { t } from "i18next";
import { API_BASE_URL } from "../../constants/Constants";
import Select from 'react-select';
import NearMouseTooltip from "./helpers/NearMouseTooltip";
import { Icon } from "@fluentui/react";
import AugmentoIcon from "./SVGComponents/AugmentoIcon";
import WidgetSelectStyles from "./WidgetSelectStyles";
import DownArrowIcon from "./DownArrowIcon";
import OpenWidgetHeader from "./OpenWidgetHeader";

const tooltipStyles = {
  root: { display: "inline-block", marginRight: 8 },
};


const severityOptions = [
  { label: "All", value: "All", color: null },
  { label: "Low", value: "Low", color: "green" },
  { label: "Medium", value: "Medium", color: "#FFFF00" },
  { label: "High", value: "High", color: "#FF6600" },
  { label: "Critical", value: "Critical", color: "#FC0000" },
];


const handleOpenViewerWindow = async (studyId, firmId, userName, isReportClicked,isAugDemo,isProductivityClicked, chartMode) => {
    try {
      let response = null;
      if(isAugDemo){
        response = await fetch(`https://augmento-demo.deeptek.ai:8002/gizmo/generate-access-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ studyId, firmId, isReportClicked,isProductivityClicked,chartMode }),
      });
      }
      else{
        response = await fetch(`${API_BASE_URL}jwtServices/gizmo/generate-access-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ studyId, firmId, isReportClicked,isProductivityClicked,chartMode }),
      });
      }
      

      if (!response.ok) {
        const error = await response.text();
        console.error("Failed to generate access code:", error);
        alert("Unable to open viewer.");
        return;
      }

      const data = await response.json();
      const accessCode = data.accessCode;
      let viewerUrl = null;
      if(isAugDemo){
        viewerUrl = `https://augmento-demo.deeptek.ai/gizmo-viewer?accessCode=${encodeURIComponent(accessCode)}&userName=${encodeURIComponent(userName)}`;
      }
      else{
        viewerUrl = `${window.location.origin}/gizmo-viewer?accessCode=${encodeURIComponent(accessCode)}&userName=${encodeURIComponent(userName)}`;
      }
      window.parent.postMessage({ type: "open-external", url: viewerUrl }, "*");
    } catch (err) {
      console.error("Error in handleOpenViewerWindow:", err);
      alert("Something went wrong while opening the viewer.");
    }
  };


const checkForHourGlass = (study) => {
  return (
    (study.aiProcessed === 2 && study.aiEmergencyMax === -1) ||
    (study.reportDoneStatus !== 2 && study.aiProcessed === 2)
  );
};

const getAIIcon = (study) => {
  if (
    (study.aiEmergencyMax === -1 && study.aiProcessed === 0) ||
    (study.reportDoneStatus !== 2 && study.aiProcessed === 0) ||
    study.aiProcessed === 3
  ) {
    return (
      <NearMouseTooltip
        content={t("study-list.filters.no-ai-output")}
        styles={tooltipStyles}
      >
        <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
            
        <NoAIOutput />
        </div>
      </NearMouseTooltip>
    );
  }

  if (checkForHourGlass(study)) {
    return (
      <NearMouseTooltip
        content={t("study-list.badges.in-progress")}
        styles={tooltipStyles}
      >
        <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
        <Icon iconName="HourGlass" /></div>
      </NearMouseTooltip>
    );
  }

  switch (study.aiEmergencyMax) {
    case -3:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.non-frontal")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
          <NonFrontal /></div>
        </NearMouseTooltip>
      );
    case 0:
    case 1:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.low")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
        
          <Low /></div>
        </NearMouseTooltip>
      );
    case 2:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.medium")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
        
          <Medium /></div>
        </NearMouseTooltip>
      );
    case 3:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.high")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
          <High /></div>
        </NearMouseTooltip>
      );
    case 4:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.critical")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
          <Critical /></div>
        </NearMouseTooltip>
      );
    case 6:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.fo-only")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
          <ForeignBody /></div>
        </NearMouseTooltip>
      );
    case 7:
      return (
        <NearMouseTooltip
          content={t("study-list.filters.suspect")}
          styles={tooltipStyles}
        >
          <div style={{ minHeight: "33px", display: "flex", alignItems: "center", justifyContent: 'center', width:'100%', height: '100%' }}>
        
          <Suspect /></div>
        </NearMouseTooltip>
      );
    default:
      return null;
  }
};

const rowStyle = {
  // background: "rgba(217, 217, 217, 0.08)",
  height: "33px", 
  borderBottom: "2px groove rgba(255, 255, 255, 0.15)",
};

const textStyle = {
  color: "#F5F5F5",
  fontSize: 12,
  fontFamily: "Open Sans",
  fontWeight: 400,
};

const NextStudiesTable = ({ studies ,userName,setShowNextStudies,setSomePredictionId}) => {
  const [selectedSeverity, setSelectedSeverity] = useState("All");
  const [visibleCount, setVisibleCount] = useState(8);
  const scrollRef = useRef(null);

  const hasStudies = Array.isArray(studies) && studies.length > 0;
  
useEffect(() => {
if(selectedSeverity){
  setSomePredictionId(selectedSeverity);
}

},[selectedSeverity]
);
const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: '#1A1D25',
    borderRadius: '50px',
    border: '1px solid #F5F5F5',
    minHeight: '25px',
    height: '25px',
    width:'116px',
    fontSize: '11px',
    padding: 0,       // removed padding
    margin: 0,    
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 0px',
  }),
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: state.isFocused ? '#26364F' : '#1A1D25',
    color: '#F5F5F5',
    fontSize: '11px',
    // padding: '6px 10px',
            padding: 0,       // removed padding
    margin: 0,  
  }),
  singleValue: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    color: '#F5F5F5',
    fontSize: '11px',
            padding: 0,       // removed padding
    margin: 0,  
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '0px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
    menu: (base) => ({
    ...base,
    backgroundColor: '#040811',
    borderRadius: '4px',
    marginTop: 2,
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: '#040811',
    borderRadius: '8px',
    padding: 1,
  }),
};

const handleScroll = () => {
    const el = scrollRef.current;
    if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setVisibleCount((prev) => Math.min(prev + 5, studies.length));
    }
  };

  const visibleStudies = studies.slice(0, visibleCount);

const formatOptionLabel = ({ label, color }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
  {color != null &&  (<div
      style={{
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: 6,
        // marginLeft: 6
      }}
    />)}
    {color == null &&  (<div
      style={{
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: '2px solid #F5F5F5',
        marginRight: 6,
        // marginLeft: 6
      }}
    />)}
    <div style={{ flex: 1, textAlign: 'left' ,marginLeft:'5px'}}>{label}</div>
  </div>
  </div>
);

  return (
    <>
    <OpenWidgetHeader
      options={severityOptions}
      selectedValue={selectedSeverity}
      onChangeValue={setSelectedSeverity}
      SelectStyles={WidgetSelectStyles}
      leftSelectWidth="105px"
      formatOptionLabel={formatOptionLabel}
      rightIcons={[
        {
          key: 'close-next-studies',
          onClick: () => setShowNextStudies(false),
          Icon: DownArrowIcon,
          style: { marginLeft: '0px' },
        },
      ]}
    />

    <div ref={scrollRef} onScroll={handleScroll} style={{height:"198px"}} className="custom-scrollbar">
      <table
        style={{
          borderCollapse: "collapse",
          tableLayout: "fixed",
           width: "96%", 
           margin: '0 0 0 10px', 
        }}
      >
        
        <tbody>
  {hasStudies ? (
    visibleStudies.map((study, idx) => (
      
        <tr
          onDoubleClick={() =>
            handleOpenViewerWindow(study.studyId, study.firmId, userName, true,false,false,"")
          }
          style={{ ...rowStyle }}
        >
          
          <td style={{ height: "33px", padding: "0 8px", width: "16px" }}>
              {getAIIcon(study)}
          </td>
          
          <td
  style={{
    ...textStyle,
    width: "170px",
    padding: "0 8px",
    height: '33px',
 }}
>
  <NearMouseTooltip content={study.patientId}>
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "168px", // Adjust width as needed
        lineHeight: "1.2",
      }}
    >
      {study.patientId}
    </div>
    </div>
  </NearMouseTooltip>
</td>
          
          <td style={{ ...textStyle, width: "60px", padding: "0 8px 0 0", height: '33px'}}>
            <NearMouseTooltip content={t("Double Click To View Study")} key={idx}>
            {study.patientSex} / {study.patientAge}
            </NearMouseTooltip>
          </td>
          
          
          <td style={{ ...textStyle, width: "40px", padding: "0 8px 0 0", height: '33px' }}>
            <NearMouseTooltip content={t("Double Click To View Study")} key={idx}>
            {study.modality}
          </NearMouseTooltip>
          </td>
        </tr>
      
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
        {t("No studies available")}
      </td>
    </tr>
  )}
</tbody>
      </table>
    </div>
           {/* <div style={{ position: "relative", height: "34px", backgroundColor: "#0C1A2C", zIndex: 1000 }}>
            <div
              style={{
                position: "absolute",
                right: 10,
                paddingTop:"2px"
              }}
            >
            <AugmentoIcon />
          </div>
        </div> */}
    </>
  );
};

export default NextStudiesTable;
